import { Link } from 'react-router-dom';

interface Crumb {
  label: string;
  path?: string;
}

interface BreadcrumbsProps {
  items: Crumb[];
}

export default function Breadcrumbs({ items }: BreadcrumbsProps) {
  return (
    <nav aria-label="面包屑导航" className="mb-6">
      <ol className="flex flex-wrap items-center gap-x-2 gap-y-1 text-xs text-foreground-500">
        <li className="flex items-center gap-2">
          <Link to="/" className="inline-flex items-center gap-1 transition-colors hover:text-primary-400">
            <i className="ri-home-4-line"></i>
            首页
          </Link>
        </li>
        {items.map((item, index) => (
          <li key={`${item.label}-${index}`} className="flex items-center gap-2">
            <i className="ri-arrow-right-s-line text-foreground-600"></i>
            {item.path ? (
              <Link to={item.path} className="transition-colors hover:text-primary-400">
                {item.label}
              </Link>
            ) : (
              <span className="text-foreground-300">{item.label}</span>
            )}
          </li>
        ))}
      </ol>
    </nav>
  );
}